import { gql } from "@apollo/client";
import { values } from "./helper";

export const typeDef = gql`
  type Advert {
    id: ID!
    name: String
    description: String
    url: String
    targetBlank: Boolean
    sort: Int
    thumbnailUrl: String
    copyright: String
  }
`;

export const resolvers = {
  Advert: {
    name: (ad) => ad.display_name,
    targetBlank: (ad) => values(ad, "target_blank"),
    sort: (ad) => values(ad, "sort"),
    thumbnailUrl: (ad) => ad?.creatives?.[0]?.url,
    copyright: (ad) => ad?.creatives?.[0]?.copyright,
  },
};
